import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const Search = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => { }}
      style={style}
      width={width ? width : height ? height : 100}
      height={height ? height : width ? width : 100}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.62 13.11l4.54 4.54c.32.32.32.84 0 1.16l-.35.35a.82.82 0 01-1.16 0l-4.54-4.54a.86.86 0 01-.13-.17 7.71 7.71 0 111.47-1.47c.06.03.12.08.17.13zm-6.3.99a5.78 5.78 0 100-11.57 5.78 5.78 0 000 11.57z"
        fill={color ? color : neutral[700]}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Search;
